import {VueI18n} from "@zoovu/runner-browser-api";
import {StandardTextsConfiguration, LocalizedMessage, Message} from "../configuration";

export default function standardTextsToVueI18n(standardTexts: StandardTextsConfiguration): VueI18n.LocaleMessageObject {
    if (!standardTexts.sections || !standardTexts.locales) {
        return {};
    }

    const flatMessages = standardTexts.sections
        .reduce((allMessages, section) => [
            ...allMessages,
            ...section.messages || []
        ], [])
        .reduce((allLocalizations, message: Message) => [
            ...allLocalizations,
            ...message.localizations.reduce((messageLocalizations, localization: LocalizedMessage) => [
                ...messageLocalizations,
                {
                    id: message.id,
                    locale: localization.locale,
                    value: localization.value,
                },
            ], [])
        ], []);

    return standardTexts.locales
        .reduce((localeMessages, locale) => ({
            ...localeMessages,
            [locale]: flatMessages
                .filter((fm) => fm.locale === locale)
                .reduce((messages, message) => ({
                    ...messages,
                    [message.id]: message.value
                }), {})
        }), {});
}
